import { render } from "./ProductCreatePage.vue?vue&type=template&id=2c3ab5ae&scoped=true"
import script from "./ProductCreatePage.vue?vue&type=script&lang=js"
export * from "./ProductCreatePage.vue?vue&type=script&lang=js"

import "./ProductCreatePage.vue?vue&type=style&index=0&id=2c3ab5ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c3ab5ae"]])

export default __exports__